import { EventEmitter, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Subscription, catchError, fromEvent, map, merge, throwError } from 'rxjs';
import { DOCUMENT, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie';
import { DataLayerError, NewTag } from '../models/node';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalShareComponent } from '../components/blocks/modal-share/modal-share.component';
import Swal from 'sweetalert2';
declare var require: any

@Injectable()
export class HelpersService {
    // STORAGE
    private projectName = 'lumsa-fe-storage-';
    public storageProjectCacheableKey = 'lumsa-cacheable';
    private storageLanguage = 'lumsa-lang';
    private storageAccessTokenKey = this.projectName + 'access-token';
    public storageAccessTokenAdminKey = this.projectName + 'access-token-admin';
    public cookieAccessTokenAdminKey = 'access-token-admin';
    private storageRefreshTokenKey = this.projectName + 'refresh-token';
    private storageExpiresInAccessToken = this.projectName + 'expires-in-access-token';
    private storageExpiresInRefreshToken = this.projectName + 'expires-in-refresh-token';
    private storageIsLogged = this.projectName + 'is-logged';
    private storageCountRefresh = this.projectName + 'count-refresh';
    // CONSTANTS
    public routeHome = `home`;
    public routeLogin = `auth/login`;
    public routeError = 'error/503';
    public DAYS_EXPIRE_REFRESH_TOKEN = 30;
    // TRANSLATE
    public languages = environment.languages;
    // EVENTS GLOBAL
    public onEndCheckUserAuth = new EventEmitter();
    public onChangeLang = new EventEmitter();
    public menuIsOpen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public menuHeaderOpenBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    // public menuHeaderOpenedBS: BehaviorSubject<any> = new BehaviorSubject<any>({opened: false, id: ""});
    public menuHeaderClickedIdBS: BehaviorSubject<string> = new BehaviorSubject<string>("");
    public viewFilters: any;
    public taxonomies: any;
    public stringView: string = '';
    public scrollOnTopBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public openLocalMenuBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public showLocalMenuBS: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    // OTHER
    private timeoutAccessToken: any;
    public isBrowser: boolean;
    public isScreenMobile = false;
    private windowResize: Subscription = new Subscription();
    public nodeType: String | null = null;


    constructor(protected http: HttpClient,
        protected router: Router,
        @Inject(PLATFORM_ID) protected platformId: Object,
        protected cookieService: CookieService,
        protected title: Title,
        protected translate: TranslateService,
        protected meta: Meta,
        protected modalService: NgbModal,
        protected viewportScroller: ViewportScroller,
        @Inject(DOCUMENT) protected doc: Document
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
        if (this.isBrowser) {
            this.isScreenMobile = document.body.offsetWidth < 1024;
        }

        this.translate.onLangChange.subscribe(lang => {
            this.onChangeLang.emit(this.langCodeApi);
        })
        // this.checkSreenSize();
    }

    
    private checkSreenSize() {
        if (this.isBrowser) {
            this.windowResize = merge(
                fromEvent(window, 'resize'),
            ).subscribe((event: Event)=> {
                this.isScreenMobile = document.body.offsetWidth < 1024;
            });
        }
    }

    //i18n

    public setLanguage(lang: string, refresh = true): void {
        this.setLocalStorage(this.storageLanguage, lang);
    }

    get lang(): string {
        const lang = <string>this.getLocalStorage(this.storageLanguage);
        return lang ?? "it-IT";
    }

    get langCodeApi(): string {
        let langCode = <string>this.getLocalStorage(this.storageLanguage);
        if (langCode) {
            const found = this.languages.findIndex(l => l.code === langCode);
            if (found >= 0) {
                return this.languages[found].codeApi;
            } else {
                return this.defaultLang.codeApi;
            }
        } else {
            return this.defaultLang.codeApi;
        }
    }

    get langsCode(): string[] {
        const ret = [];
        for (const lang of this.languages) {
            ret.push(lang.code);
        }
        return ret;
    }

    get defaultLang(): any {
        const ret = this.languages.filter(l => l.default)[0];
        return ret;
    }

    get defaultLangCode(): string {
        const ret = this.languages.filter(l => l.default)[0].code;
        return ret;
    }

    public existLang(lang: string): boolean {
        let ret = false;
        if (this.languages && this.languages.length && lang) {
            const found = this.languages.findIndex(l => l.code === lang) >= 0 ? true : false;
            ret = found;
        }
        return ret;
    }

    public getIstant(key: string, params: any = null) {
        return this.translate.instant(key, params);
    }

    public useLanguage(langCode: string) {
        this.setLanguage(langCode);
        this.translate.use(langCode);
    }

    public instant(key: string, params: any = null): string {
        return this.translate.instant(key, params);
    }

    public goToHomeLang() {
        this.router.navigateByUrl(`/${this.langCodeApi}/${this.routeHome}`);
    }

    // Layout & SEO

    getWindow(): Window | null {
        return this.doc.defaultView;
    }

    getDocument(): Document | undefined {
        return this.doc.defaultView?.document;
    }

    public setTitle(title: string) {
        this.title.setTitle(title);
    }

    public setMeta(metatags: any) {

        let tagImageCheck = false;

        for (const metatag of metatags) {
            let prop = '';
            let nameAttr = '';
            let tag: any = {};
            if(metatag?.attributes?.name){
                nameAttr = "name";
                tag.content = metatag?.attributes?.content
            } else if(metatag?.attributes?.property){
                nameAttr = "property";
                tag.content = metatag?.attributes?.content
            } else {
                nameAttr = "rel";
                tag.href = metatag?.attributes?.href
            }
            if (nameAttr) {
                prop = metatag?.attributes[nameAttr];
                tag[nameAttr] = prop;

                if (prop.includes("og")) {
                    // prop = metatag?.attributes?.property.replace("_", ":");
                    if (prop.includes("image")){
                        prop = prop.replace("_0","");
                        tagImageCheck = true;
                    }
                }
                if (prop.includes("twitter")) {
                    prop = prop.replace("twitter:card", "twitter");
                    // prop = prop.replace("_", ":");
                }
                this.meta.removeTag(`${nameAttr}='${prop}'`);
                this.meta.addTag(tag);
                this.meta.updateTag(tag);
            }
        }

        if(tagImageCheck == false){
            // this.meta.addTag({ property: 'og:image', content: './assets/og-universita-lumsa.jpg' });
            // this.meta.updateTag({ property: 'og:image', content: './assets/og-universita-lumsa.jpg' });
            const window = this.getWindow();
            this.meta.addTag({ property: 'og:image', content: `${window?.frames.location.origin}/assets/images/og-universita-lumsa.jpg` });
            this.meta.updateTag({ property: 'og:image', content: `${window?.frames.location.origin}/assets/images/og-universita-lumsa.jpg` });
        }
    }

    public retrieveImage(htmlString: string, attribute: string) {
        let ret = '';
        if (htmlString) {
            const htmlparser2 = require("htmlparser2");
            const dom = htmlparser2.parseDocument(htmlString.trim());
            if (dom && dom.children && dom.children[0] && dom.children[0] && dom.children[0].name === 'img') {
                ret = dom.children[0].attribs[attribute]
            }
        }
        return ret;
    }

    public retrieveIframe(htmlString: string) {
        let dom;
        if (htmlString) {
            const htmlparser2 = require("htmlparser2");
            dom = htmlparser2.parseDocument(htmlString.trim());
            if (dom.children[0].data) {
                dom = htmlparser2.parseDocument(dom.children[0].data);
            }
        }
        return dom;
    }

    public retriveLinkTagA(htmlString: string, tag: string) {
        let ret = {
            title: '',
            hreflang: '',
            link: ''
        };
        if (htmlString) {
            const htmlparser2 = require("htmlparser2");
            const dom = htmlparser2.parseDocument(htmlString.trim());
            if (dom && dom.children && dom.children[0] && dom.children[0] && dom.children[0].name === tag && dom.children[0].children[0]) {
                ret = {
                    title: dom.children[0].children[0].data,
                    hreflang: dom.children[0].attribs.hreflang,
                    link: dom.children[0].attribs.href
                }
            }
        }
        return ret;
    }

    public retrieveDateTime(htmlString: string, attribute: string) {
        let ret = '';
        if (htmlString) {
            const htmlparser2 = require("htmlparser2");
            const dom = htmlparser2.parseDocument(htmlString.trim());
            if (dom && dom.children && dom.children[0] && dom.children[0] && dom.children[0].name === 'time') {
                ret = dom.children[0].attribs[attribute]
            }
        }
        return ret;
    }

    public createHtmlTag(htmlTag: NewTag, querySelector: string) {
        let document: any;
        if (this.getDocument()) {
            document = this.getDocument();
        }
        if (document.getElementById(htmlTag.idTag)?.getAttribute('id') === htmlTag.idTag) {
            htmlTag.attributes.forEach(atribute => {
                document.getElementById(htmlTag.idTag)?.setAttribute(atribute.nameAttribute, atribute.value);
            });
        } else {
            const newTag = document.createElement(htmlTag.nameTag);
            htmlTag.attributes.forEach(atribute => {
                newTag.setAttribute(atribute.nameAttribute, atribute.value);
            });
            document.querySelector(querySelector)?.appendChild(newTag);
        }
    }



    // Authentication

    public hasExpired(expireDate: number): boolean {
        let ret = true;
        if (expireDate) {
            const todayDate = new Date().valueOf();
            ret = expireDate > todayDate ? false : true;
        }
        return ret;
    }

    get expiresInAccessToken(): number {
        return Number(this.getLocalStorage(this.storageExpiresInAccessToken));
    }

    get expiresInRefreshToken(): number {
        return Number(this.getLocalStorage(this.storageExpiresInRefreshToken));
    }

    get accessToken(): string {
        return environment.access_token;  // NO_TOKEN decommentare
        // return this.getLocalStorage(this.storageAccessTokenKey); // NO_TOKEN commentare
    }

    get accessTokenAdmin(): string {
        return this.getLocalStorage(this.storageAccessTokenAdminKey);
    }

    get refreshToken(): string {
        return this.getLocalStorage(this.storageRefreshTokenKey);
    }

    get isLogged(): boolean {
        const ret = this.getLocalStorage(this.storageIsLogged);
        if (ret && ret === '1' && this.accessToken) {
            return true;
        } else {
            return false;
        }
    }

    public startIntervalAccessToken(): void {
        if (!this.hasExpired(this.expiresInAccessToken)) {
            let interval = this.expiresInAccessToken - new Date().valueOf();
            interval = interval < 0 ? 0 : interval;
            clearTimeout(this.timeoutAccessToken);
            if (this.isBrowser) console.log('end interval refresh ', new Date(new Date().getTime() + interval));
            if (this.isBrowser) {
                this.timeoutAccessToken = setTimeout(() => {
                    this.callRefreshAccessToken();
                }, interval);
            }
            this.onEndCheckUserAuth.emit(true);
        } else {
            this.onEndCheckUserAuth.emit(true);
            this.logout();
            this.router.navigateByUrl(this.routeError);
        }
    }

    public callRefreshAccessToken(): void {
        this.refreshAccessToken().subscribe((res: any) => {
            clearTimeout(this.timeoutAccessToken);
            this.saveAccessToken(res);
            this.startIntervalAccessToken();
        }, (err: any) => {
            this.callLoginNoAuth();
        }
        );
    }

    private refreshAccessToken(): Observable<any> {
        let url = `${environment.urlApi}/oauth/token`;
        const req = {
            client_id: environment.client_id,
            client_secret: environment.client_secret,
            grant_type: 'refresh_token',
            refresh_token: this.refreshToken,
        };
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded;');
        const body = 'client_id=' + req.client_id + '&client_secret=' + req.client_secret + '&grant_type=' + req.grant_type + '&refresh_token=' + req.refresh_token;
        return this.http.post(url, body, { headers }).pipe(
            map((res: any) => {
                return res;
            }),
            catchError((err) => {
                return throwError(err);
            })
        );
    }

    public saveAccessToken(res: any): void {
        this.setLocalStorage(this.storageAccessTokenKey, res.access_token);
        this.setLocalStorage(this.storageRefreshTokenKey, res.refresh_token);
        const expiresIn = String(
            new Date().valueOf() + res.expires_in * 0.95 * 1000
        );
        this.setLocalStorage(this.storageExpiresInAccessToken, expiresIn);
        const dateExpireRefresh = new Date();
        dateExpireRefresh.setDate(dateExpireRefresh.getDate() + this.DAYS_EXPIRE_REFRESH_TOKEN);
        const expiresInRefresh = String(dateExpireRefresh.valueOf());
        this.setLocalStorage(this.storageExpiresInRefreshToken, expiresInRefresh);
    }



    public callLoginNoAuth(): void {
        this.loginNoAuth().subscribe(res => {
            this.localStorageSettings(res);
        }, err => {
            this.onEndCheckUserAuth.emit(true);
            this.logout();
            this.router.navigateByUrl(this.routeError);
        });
    }

    public localStorageSettings(token: any): void {
        this.setLocalStorage(this.storageIsLogged, '0');
        this.removeLocalStorage(this.storageCountRefresh);
        this.saveAccessToken(token);
        this.startIntervalAccessToken();
    }

    public loginNoAuth(): Observable<any> {
        let url = `${environment.urlApi}/oauth/token`;
        const req = {
            client_id: environment.client_id,
            client_secret: environment.client_secret,
            username: environment.username_no_auth,
            password: environment.password_no_auth,
            grant_type: 'password'
        };
        const body = 'client_id=' + req.client_id +
            '&client_secret=' + encodeURIComponent(req.client_secret) +
            '&grant_type=' + encodeURIComponent(req.grant_type) +
            '&username=' + encodeURIComponent(req.username) +
            '&password=' + encodeURIComponent(req.password);
        const headers = {
            headers: new HttpHeaders()
                .set('content-type', 'application/x-www-form-urlencoded')
        };
        return this.http.post(url, body, headers).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        );
    }

    public logout(): void {
        this.clear();
    }

    public clear(): void {
        this.removeLocalStorage(this.storageAccessTokenKey);
        this.removeLocalStorage(this.storageRefreshTokenKey);
        this.removeLocalStorage(this.storageExpiresInAccessToken);
        this.removeLocalStorage(this.storageExpiresInRefreshToken);
        clearTimeout(this.timeoutAccessToken);
    }

    // Errors

    public handleError(error: Response, preview = false): Observable<never> {
        switch (error.status) {
            case 401:
                if (!preview) {
                    this.handle401(error);
                }
                break;
            default:
        }
        return throwError(error);
    }

    private handle401(error: any): void {
        const countRefresh = this.getLocalStorage(this.storageCountRefresh);
        if (!countRefresh) {
            this.setLocalStorage(this.storageCountRefresh, '1');
            if (this.isBrowser) {
                window.location.reload();
            }
        }
    }

    public showError(error: any): void {
        let errorMsg: string = this.instant('ALERTS.MSG_ERROR_GENERIC');
        if (error && typeof error === 'string') {
            errorMsg = error;
        } else if (error.error && error.error.messageDescription) {
            errorMsg = error.error.messageDescription;
        }
    }

    // Local storage with SSR

    public getLocalStorage(key: string): any {
        let ret = null;
        if (this.isBrowser) {
            ret = localStorage.getItem(key);
        } else {
            ret = String(this.cookieService.get(key));
            ret = ret === 'undefined' ? null : ret;
        }
        return ret;
    }

    public setLocalStorage(key: string, value: string) {
        if (this.isBrowser) {
            localStorage.setItem(key, value);
        } else {
            this.cookieService.put(key, value, { path: '/', sameSite: 'none', secure: true });
        }
    }

    public removeLocalStorage(key: string) {
        if (this.isBrowser) {
            localStorage.removeItem(key);
        } else {
            this.cookieService.remove(key);
        }
    }

    // Headers 

    public getHTTPHeadersNode(preview = false): any {
        if (!this.accessToken) {
            return {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
            };
        } else {
            let accessToken = this.accessToken;
            if (preview) {
                accessToken = this.accessTokenAdmin;
            }
            return {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                }),
                observe: 'response'
            };
        }
    }
    public getHTTPHeaders(preview = false): any {
        if (!this.accessToken) {
            return {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json'
                }),
            };
        } else {
            let accessToken = this.accessToken;
            if (preview) {
                accessToken = this.accessTokenAdmin;
            }
            return {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                })
            };
        }
    }

    public dateItToUs(itDate: string) {
        const dateIt = itDate.split(" ")[0];
        const hoursIt = itDate.split(" ")[1];
        const dayIt = dateIt.split("/")[0];
        const month = dateIt.split("/")[1];
        const year = dateIt.split("/")[2];
        return `${year}-${month}-${dayIt} ${hoursIt}`
    }

    public verifyLinkExternal(link: string): boolean {
        if (link && link.substring(0, 4) === 'http') {
            return true;
        } else {
            return false;
        }
    }

    public transformResultsExport(item: any): any {
        let result: any = {};
        Object.keys(item).map((el: any, idx) => {
            if (el === 'title') {
                el = 'field_titolo'
            }
            el = el.split('_').filter((filt: any) => filt !== 'export').join('_');
            return result[el] = Object.values(item)[idx]
        });
        if (result.field_immagine) {
            if (result.field_immagine.media_image) {
                result = {
                    ...result,
                    field_immagine: result.field_immagine.media_image
                }
            }
        }
        return result;
    }

    //MODAL SHARE
    public openModaleShare(): void {
        const modalRef = this.modalService.open(ModalShareComponent, {
            scrollable: false,
            centered: true,
            size: 'lg',
        });
        let data: any;
        const path: string = window.location.href;
        data = {
            linkedin: `https://linkedin.com/sharing/share-offsite/?url=${path}`,
            facebook: `https://www.facebook.com/sharer/sharer.php?u=${path}`,
            twitter: `http://twitter.com/share?text=Im%20sharing%20on%20Twitter&url=${path}`,
            copy_text: this.copyClipboard(path)
        };
        modalRef.componentInstance.fromParent = data;
    }

    private copyClipboard(path: string): void {
        var dummy = document.createElement("textarea");
        // to avoid breaking orgain page when copying more words
        // cant copy when adding below this code
        // dummy.style.display = 'none'
        document.body.appendChild(dummy);
        //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
        dummy.value = path;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
    }


    public setDataLayerError(statusErrorCode: number, source_page: string | undefined): void {
        if(this.isBrowser) {
            const window: any = this.getWindow();
            const dataLayer: DataLayerError = {
                event: 'PageError',
                status: statusErrorCode.toString(),
                location: document.location.href,
                referral: document.referrer ? document.referrer : 'not set',
                source_page: source_page ? source_page : "not set"
            }
            if (window) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(dataLayer);
            }
        }
    }

    public viewportScroll(event: any): void {
        if (event.srcElement && event.srcElement.hash) {
            if (event.srcElement.hash.charAt(0) === '#') {
                event.preventDefault();
                const target = event.srcElement.hash.substring(1)
                this.viewportScroller.scrollToAnchor(target);
            }
        }
    }

    public sendSubscriptionNewsletter(req: any, lang: string) {
        return this.http.post(`${environment.urlApi}/${lang}/custom-rest/notification-registration?_format=json`, req, this.getHTTPHeaders()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public sendUnsubsciptionNewsletter(req: any, lang: string) {
        return this.http.post(`${environment.urlApi}/${lang}/custom-rest/notification-cancellation?_format=json`, req, this.getHTTPHeaders()).pipe(
            map((res: any) => {
                return res;
            }),
            catchError(error => {
                return this.handleError(error);
            })
        )
    }

    public showToast(message: string, type = 'success', redirectURL = '') {
        let textColor = '';
        let backgroundColor = '';
        let closeButton = false;
        let timer = 3000;
        switch (type) {
            case 'success':
                textColor = "#F4FCF4";
                backgroundColor = "#167A14";
                break;
            case 'info':
                textColor = "#000000";
                backgroundColor = "#9AA39F";
                break;
            case 'danger':
                textColor = "#FDF4F5";
                backgroundColor = "#D8293E";
                break;
        }
        const Toast = Swal.mixin({
            toast: true,
            color: textColor,
            background: backgroundColor,
            position: 'center',
            iconColor: textColor,
            customClass: {
                popup: 'toast-success',
                icon: 'border-0'
            },
            showConfirmButton: false,
            showCloseButton: closeButton,
            timer: timer,
            timerProgressBar: false,

            willClose: () => {
                if (redirectURL) {
                    this.router.navigateByUrl(redirectURL);
                }
            }
        })
        Toast.fire({
            title: message
        })
    }

    //Per testo formattato
    public modifyLinks(htmlString: string, domain: string): string {
        if (this.isBrowser) {
            const parser = new DOMParser();
            const htmlDoc = parser.parseFromString(htmlString, 'text/html');
            const fileTypes = ['application/pdf', 'application/msword', 'text/plain', 'application/vnd.ms-excel', 'application/vnd.ms-powerpoint', 'application/vnd.oasis.opendocument.text', 'application/vnd.oasis.opendocument.spreadsheet', 'application/vnd.oasis.opendocument.presentation', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'application/zip', 'application/x-rar-compressed', 'text/csv'];
    
            htmlDoc.querySelectorAll('a').forEach((link: any) => {
                const type = link.getAttribute('type');
                if (type && fileTypes.includes(type) && !link.getAttribute('href').includes('http') ) { // se ha il type presente nella lista sopra e è relativo
                    link.setAttribute('href', domain + link.getAttribute('href'));
                    link.setAttribute('target', '_blank');
                    link.classList.add('pdf-text-custom');
                } else if (link.getAttribute('href') && !link.getAttribute('href').startsWith('mailto') && !link.getAttribute('href').startsWith('tel')) { 
                    if (link.getAttribute('href').includes('/sites') && !link.getAttribute('href').includes('http')) { // se è relativo
                        link.setAttribute('href', domain + link.getAttribute('href'));
                    }
    
                    if (link.getAttribute('href').includes('http') && !link.getAttribute('target')) { // se è assoluto
                        link.setAttribute('target', '_blank');
                    }
                }
            });
    
            htmlDoc.querySelectorAll('img').forEach(img => {
                img.setAttribute('src', domain + img.getAttribute('src'));
            });
    
            htmlDoc.querySelectorAll('table').forEach(table => {
                const div = document.createElement('div');
                div.classList.add('table-responsive');
                table.classList.add('table');
                if (table && table.parentNode) {
                    table.parentNode.insertBefore(div, table);
                    div.appendChild(table);
                }
            });
    
            return htmlDoc.body.innerHTML;
        } else {
            return "";
        }
    }

    setStyleTables(renderer: any) {
        // Seleziona tutte le tabelle
        if (this.isBrowser) {
            const tables = this.getDocument()?.querySelectorAll('table');
            if (tables) {
              tables.forEach((table) => {
                // Assegna la classe di Bootstrap
                renderer.addClass(table, 'table');
                renderer.addClass(table, 'table-borderless');
                renderer.addClass(table, 'border-0');
          
                // Trova il numero di colonne
                const numColumns = table.querySelector('tr')?.children.length;
          
                // Assegna la larghezza delle colonne
                let columnWidth: any;
                if (numColumns) {  
                  columnWidth = 100 / numColumns + '%';
                }
                const cells = table.querySelectorAll('th, td');
                cells.forEach((cell) => {
                  renderer.setStyle(cell, 'width', columnWidth);
                  renderer.setStyle(cell, 'overflow', 'hidden');
                  renderer.setStyle(cell, 'text-overflow', 'ellipsis');
                  renderer.setStyle(cell, 'white-space', 'nowrap');
                });
          
                // Colora le righe in modo alternato
                const rows = table.querySelectorAll('tbody tr');
                rows.forEach((row, idx) => {
                  if (idx % 2 === 0) {
                    renderer.setStyle(row, 'background-color', '#FFFFFF');
                  } else {
                    renderer.setStyle(row, 'background-color', '#F5F6F6');
                  }
                });
              });
            }
        }
    }   

    public setDataAttributes(sel: string, attributes: any) {
        if (this.isBrowser) {
            const labels: any = document.querySelectorAll(sel);
            for (let label of labels) {
                for (let attribute of attributes) {
                    label.setAttribute(attribute.name, attribute.value)
                }
            }
        }
    }


    public convertDateToTimestamp(date: any) {
        let timestamp;
        if (date && new Date(date)) {
            timestamp = new Date(date).valueOf();
        }
        return timestamp;
    }

    public lastChar(string: string) {
        const s = string;
        const lChar = s.charAt(s.length - 1);
        return lChar;
    }


}


